module.exports = __webpack_public_path__ + "img/form_bj.cf7b5a7.png";